var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDunpai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1764207663006,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3593,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M533.333333 128c120.874667 79.530667 241.792 143.189333 362.666667 190.72 0 312.149333-120.874667 518.784-362.666667 619.946667C291.541333 837.504 170.666667 630.869333 170.666667 318.72 291.541333 271.189333 412.458667 207.573333 533.333333 128z m102.869334 287.402667l-136.277334 143.274666-68.053333-71.68-68.138667 71.68 136.234667 143.274667 204.373333-214.912-68.138666-71.68z",
    fill: "#1677FF",
    "p-id": 3594
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDunpai);
export default __webpack_public_path__ + "static/media/dunpai.0e9d3c6554bc53fbd779e3d29509847b.svg";
export { ForwardRef as ReactComponent };